var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcelV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 40,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9289 0H2C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H16C17.1046 24 18 23.1046 18 22V7.07106L10.9289 0Z",
    fill: "#237F4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57141 16.6737L7.95159 12.9337L5.77079 9.21428H7.52506L8.71515 11.5929C8.82503 11.8189 8.90033 11.9866 8.94107 12.0974H8.9565C9.03469 11.9171 9.11699 11.7421 9.20341 11.5722L10.4756 9.21554H12.086L9.84968 12.913L12.1428 16.6737H10.4293L9.05465 14.0629C8.9899 13.9518 8.93495 13.8351 8.89046 13.7142H8.8701C8.82983 13.8327 8.7764 13.9461 8.71084 14.0523L7.29545 16.6737H5.57141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelV2);
export default __webpack_public_path__ + "static/media/excel_v2.813941ac5f8ae3bb9426722b2f299a8d.svg";
export { ForwardRef as ReactComponent };